import { graphql, compose } from 'react-apollo';
import MobileMenu from './MobileMenu';
import { withLocalization } from '../../../utils';
import gameCategoriesQuery from '../../../apollo/queries/gameCategoriesQuery';

export default compose(graphql(gameCategoriesQuery, { name: 'gameCategories' }), withLocalization)(MobileMenu);
